import api from "./api";
import { generateErrorMessage } from "../utils/message";


/*Ewsreports*/
export const registerEwsreport = async (ewsreportData) => {
  try {
    const response = await api.post("/ewsreports", ewsreportData);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("register", "ewsreport");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const fetchEwsreportsFromAPI = async (page = 1, perPage = 10, search, columnFilters = {}, signal) => {
  try {
    const params = { page, per_page: perPage };
    if (search) params.search = search;

    // Add column-specific filters
    if (columnFilters.model) params.model = columnFilters.model;
    if (columnFilters.level) params.level = columnFilters.level;
    if (columnFilters.part_number) params.part_number = columnFilters.part_number;
    if (columnFilters.part_name) params.part_name = columnFilters.part_name;
    if (columnFilters.unique) params.unique = columnFilters.unique;

    const response = await api.get("/ews/details", {
      params: params,
      signal, // aborts this request when a newer page/filter fetch supersedes it
    });

    return response.data.data;
  } catch (error) {
    const fallback = generateErrorMessage("get data", "ewsreport");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const deleteEwsreportsFromAPI = async (ewsreportId) => {
  try {
    const response = await api.delete(`/ewsreports/${ewsreportId}`, {
      params: { ewsreport_id: ewsreportId },
    });
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("delete data", "ewsreport");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};


export const fetchEwsreportsById = async (ewsreportId) => {
  try {    
    const response = await api.get(`/ewsreports/${ewsreportId}`);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("get data ewsreport", "ewsreport");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const updateEwsreport = async (id, ewsreportData) => {
  try {
    const response = await api.put(`/ewsreports/${id}`, ewsreportData);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("update", "ewsreport");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};



// The export endpoints stream the Excel/PDF directly (Content-Disposition
// attachment); they no longer return a { filePath } JSON. So request the
// response as a blob and hand it to the browser as a download.
const triggerBlobDownload = (response, fallbackName) => {
  const contentType = response.headers?.["content-type"] || response.data?.type;
  const blob = new Blob([response.data], contentType ? { type: contentType } : undefined);
  const disposition = response.headers?.["content-disposition"] || "";
  const match = /filename="?([^";]+)"?/i.exec(disposition);
  const filename = match ? match[1] : fallbackName;

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

// With responseType 'blob' an error body also arrives as a Blob, so read it back
// as text to recover the API's message.
const readBlobErrorMessage = async (error, fallback) => {
  const data = error?.response?.data;
  if (data instanceof Blob) {
    try {
      return JSON.parse(await data.text())?.message || fallback;
    } catch (_) {
      return fallback;
    }
  }
  return data?.message || fallback;
};

export const downloadStockFileFromAPI = async (fileType, search) => {
  try {
    const response = await api.post(
      `/ews/download/display-ews/${fileType}/stock-report/ALL`,
      search,
      { responseType: "blob" },
    );
    triggerBlobDownload(
      response,
      `stock_report_${Date.now()}.${fileType === "pdf" ? "pdf" : "xlsx"}`,
    );
  } catch (error) {
    throw new Error(
      await readBlobErrorMessage(
        error,
        generateErrorMessage("download stock report", "EWS stock report"),
      ),
    );
  }
};

export const downloadEwsStockReportPdfFromAPI = async (search) => {
  try {
    const response = await api.post(`/ews/stock-report/pdf`, search, {
      responseType: "blob",
    });
    triggerBlobDownload(response, `ews_stock_report_${Date.now()}.pdf`);
  } catch (error) {
    throw new Error(
      await readBlobErrorMessage(
        error,
        generateErrorMessage("download EWS stock report PDF", "EWS stock report"),
      ),
    );
  }
};


